document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var cartType = document.body.getAttribute('data-cart-type') || 'drawer';

  /* ------------------------------------------------------------------
     Mobile menu
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-mobile-menu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var menu = document.getElementById('pg-mobile-menu');
      if (menu) menu.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-mobile-menu-close]').forEach(function (btn) {
    btn.addEventListener('click', closeMobileMenu);
  });
  function closeMobileMenu() {
    var menu = document.getElementById('pg-mobile-menu');
    if (menu) menu.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
  }

  /* ------------------------------------------------------------------
     Cart drawer open/close
     ------------------------------------------------------------------ */
  var drawer = document.getElementById('pg-cart-drawer');

  function openCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
  }
  document.querySelectorAll('[data-cart-drawer-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartType !== 'drawer') return; // let link go to /cart
      e.preventDefault();
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
    btn.addEventListener('click', closeCartDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMobileMenu();
      closeCartDrawer();
    }
  });

  /* ------------------------------------------------------------------
     Quantity steppers (product page + cart)
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var stepBtn = e.target.closest('[data-qty-step]');
    if (!stepBtn) return;
    var wrapper = stepBtn.closest('.pg-qty-selector');
    var input = wrapper.querySelector('input[type="number"]');
    if (!input) return;
    var step = parseInt(stepBtn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var newVal = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.value = newVal;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------------
     Cart count / render helpers
     ------------------------------------------------------------------ */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function money(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + ' kr';
  }

  function renderDrawerLine(item) {
    var variantText = item.variant_title && item.variant_title !== 'Default Title'
      ? '<div class="pg-cart-line-variant">' + item.variant_title + '</div>' : '';
    return (
      '<div class="pg-cart-line" data-line-key="' + item.key + '">' +
        '<img src="' + (item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2') : '') + '" alt="' + (item.product_title || '') + '" width="90" height="90">' +
        '<div>' +
          '<div class="pg-cart-line-title">' + item.product_title + '</div>' +
          variantText +
          '<div class="pg-qty-selector pg-qty-selector--sm" data-line-key="' + item.key + '">' +
            '<button type="button" data-drawer-qty-step="-1" aria-label="Reduser antall">–</button>' +
            '<input type="number" min="0" value="' + item.quantity + '" data-drawer-qty-input readonly>' +
            '<button type="button" data-drawer-qty-step="1" aria-label="Øk antall">+</button>' +
          '</div>' +
          '<button type="button" class="pg-cart-line-remove" data-drawer-remove data-line-key="' + item.key + '">Fjern</button>' +
        '</div>' +
        '<div class="pg-cart-line-price">' + money(item.final_line_price) + '</div>' +
      '</div>'
    );
  }

  function renderDrawer(cart) {
    var body = document.getElementById('pg-cart-drawer-body');
    var footer = document.getElementById('pg-cart-drawer-footer');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="pg-cart-drawer-empty"><p>Handlekurven din er tom.</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    body.innerHTML = cart.items.map(renderDrawerLine).join('');
    if (footer) {
      footer.style.display = 'block';
      var subtotalEl = footer.querySelector('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    }
  }

  function refreshCart(openDrawer) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderDrawer(cart);
        if (openDrawer && cartType === 'drawer') openCartDrawer();
        else if (openDrawer) window.location.href = '/cart';
      });
  }

  /* ------------------------------------------------------------------
     Add to cart (progressive enhancement over normal form POST)
     ------------------------------------------------------------------ */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Legger til …';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        refreshCart(true);
      })
      .catch(function () {
        // Fallback: normal submit if fetch/JS path fails
        form.submit();
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      });
  });

  /* ------------------------------------------------------------------
     Cart drawer line quantity / remove
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-drawer-remove]');
    var stepBtn = e.target.closest('[data-drawer-qty-step]');

    if (removeBtn) {
      changeLine(removeBtn.getAttribute('data-line-key'), 0);
    } else if (stepBtn) {
      var wrap = stepBtn.closest('[data-line-key]');
      var input = wrap.querySelector('[data-drawer-qty-input]');
      var newQty = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(stepBtn.getAttribute('data-drawer-qty-step'), 10));
      changeLine(wrap.getAttribute('data-line-key'), newQty);
    }
  });

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        renderDrawer(cart);
      });
  }

  /* ------------------------------------------------------------------
     Product gallery thumbnails
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (mainImg) {
          mainImg.src = thumb.getAttribute('data-full-src');
          mainImg.alt = thumb.getAttribute('data-alt') || mainImg.alt;
        }
      });
    });
  });

  /* ------------------------------------------------------------------
     Variant picker
     ------------------------------------------------------------------ */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var jsonEl = form.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var variantIdInput = form.querySelector('[data-variant-id]');
    var priceEl = form.querySelector('[data-price]');
    var comparePriceEl = form.querySelector('[data-compare-price]');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var stockNote = form.querySelector('[data-stock-note]');

    function getSelectedOptions() {
      var selected = [];
      form.querySelectorAll('[data-option-index]').forEach(function (group) {
        var index = group.getAttribute('data-option-index');
        var active = group.querySelector('.is-selected');
        var val = active ? active.getAttribute('data-value') : (group.value || null);
        selected[index] = val;
      });
      return selected;
    }

    function findVariant() {
      var selected = getSelectedOptions();
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-label-unavailable') || 'Ikke tilgjengelig';
        }
        if (stockNote) stockNote.textContent = 'Denne kombinasjonen er ikke tilgjengelig.';
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = money(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-label-add') || 'Legg i handlekurv';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-label-soldout') || 'Utsolgt';
        }
      }
      if (stockNote) {
        stockNote.textContent = variant.available ? '' : 'Denne varianten er utsolgt.';
      }
      if (variant.featured_media) {
        var thumb = form.closest('.pg-product') && form.closest('.pg-product').querySelector('[data-gallery-thumb][data-media-id="' + variant.featured_media.id + '"]');
        if (thumb) thumb.click();
      }
    }

    form.querySelectorAll('[data-swatch]').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('[data-option-index]');
        group.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-selected'); });
        swatch.classList.add('is-selected');
        updateUI();
      });
    });
    form.querySelectorAll('select[data-option-index]').forEach(function (select) {
      select.addEventListener('change', updateUI);
    });

    updateUI();
  });
});
